import { render, staticRenderFns } from "./SectionStatusIcon.vue?vue&type=template&id=0b4b16d3&scoped=true&"
import script from "./SectionStatusIcon.vue?vue&type=script&lang=js&"
export * from "./SectionStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./SectionStatusIcon.vue?vue&type=style&index=0&id=0b4b16d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4b16d3",
  null
  
)

export default component.exports